export const billingOnly = state => Boolean(state.requiresReauthentication || state.institutionAccess === 'billing_only' || state.entidade?.platform_access_suspended_at);
